import import_latest_version_module from '@/component/admin-layout/import_latest_version_module';

export default {
  path: '',
  component: () => import_latest_version_module(),
  children: [
    {
      path: '/admin/cancel-order-management',
      name: 'admin-cancel-order-management',
      component: () => import(/* webpackChunkName: "page-admin-plain-order-management-cancel-order-management" */ `./index.vue`),
      meta: {
          data_for_admin_layout: {
                    data_for_history_tag: {
                              entity: {
                                        name: "取消订单列表"
                              }
                    },
                    data_for_breadcrumb: {
                              entity_list: [
                                        {
                                                  name: "订单管理"
                                        },
                                        {
                                                  name: "取消订单列表"
                                        }
                              ]
                    }
          }
},
    },
  ],
};
